import { Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { PhoneIcon, Wordmark } from "./design";
import { VITANARA_BERATUNG_DISPLAY, VITANARA_BERATUNG_TEL } from "../lib/contact";

export default function PublicHeader() {
  const { user } = useAuth();
  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 30,
        background: "rgba(244,236,216,0.85)",
        backdropFilter: "saturate(140%) blur(8px)",
        WebkitBackdropFilter: "saturate(140%) blur(8px)",
        borderBottom: "1px solid rgba(43,26,15,0.08)",
      }}
    >
      <div
        style={{
          maxWidth: 960,
          margin: "0 auto",
          padding: "16px 22px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 14,
        }}
      >
        <Link
          to="/"
          aria-label="Vitanara Startseite"
          style={{ textDecoration: "none" }}
        >
          <Wordmark />
        </Link>
        <nav
          style={{
            display: "flex",
            alignItems: "center",
            gap: 16,
          }}
        >
          <a
            href={`tel:${VITANARA_BERATUNG_TEL}`}
            title="Kundenberatung"
            style={{
              display: "none",
              alignItems: "center",
              gap: 6,
              fontFamily: "var(--f-ui)",
              fontSize: 13,
              color: "var(--ink-soft)",
              textDecoration: "none",
            }}
            data-mq-sm
          >
            <PhoneIcon />
            Beratung {VITANARA_BERATUNG_DISPLAY}
          </a>
          <Link
            to="/pakete"
            data-mq-md
            style={{
              display: "none",
              fontFamily: "var(--f-ui)",
              fontSize: 14,
              color: "var(--ink-soft)",
              textDecoration: "none",
            }}
          >
            Pakete
          </Link>
          {user ? (
            <Link
              to="/dashboard"
              className="btn-secondary"
              style={{
                padding: "9px 16px",
                minHeight: 0,
                fontSize: 14,
              }}
            >
              Mein Bereich
            </Link>
          ) : (
            <>
              <Link
                to="/login"
                style={{
                  fontFamily: "var(--f-ui)",
                  fontSize: 14,
                  color: "var(--ink-soft)",
                  textDecoration: "none",
                }}
              >
                Anmelden
              </Link>
              <Link
                to="/onboarding"
                className="btn-primary"
                style={{
                  padding: "10px 18px",
                  minHeight: 0,
                  fontSize: 14,
                }}
              >
                Jetzt starten
              </Link>
            </>
          )}
        </nav>
      </div>
      <style>{`
        @media (min-width: 640px) {
          [data-mq-sm] { display: inline-flex !important; }
        }
        @media (min-width: 768px) {
          [data-mq-md] { display: inline-flex !important; }
        }
      `}</style>
    </header>
  );
}
